module.exports = __webpack_public_path__ + "static/media/hab10-0.4f560359.jpg";